<script setup lang="ts">
const drawer = ref(false);

function closeDrawer() {
	drawer.value = false;
}
</script>

<template>
	<header class="mobile-header">
		<div class="mobile-header__start">
			<HmLogo :to="{ name: 'index' }" />
		</div>
		<div class="mobile-header__end">
			<HmButtonIcon
				icon="list"
				label="Open App Switcher"
				severity="basic"
				is-circle
				@click="drawer = true"
			/>
		</div>

		<PvDrawer
			position="right"
			:show-close-icon="false"
			v-model:visible="drawer"
		>
			<button type="button" class="p-drawer-close" @click="closeDrawer">
				<HmIcon name="x" />
			</button>

			<div class="mobile-drawer">
				<ArticleAppSwitcher />
				<ArticleNavigation @navigate="closeDrawer" />

				<HmCopyright has-help />
			</div>
		</PvDrawer>
	</header>
</template>

<style lang="scss">
@layer components
{
	.mobile-header
	{
		@include flex(between, center);
		width:100%;
		height:var(--height-header);
		background-color:color-opacity(var(--bg-basic-0), 64);
		@include blur(16);
		padding-inline:$spacing-sm;
		position:fixed;
		inset:0 auto auto 0;
		z-index:900;

		@include responsive(lg)
		{
			display:none;
		}

		.logo
		{
			@include size(146, 40);
		}
	}

	.mobile-drawer
	{
		flex-grow:1;
		@include flex(null, null, 40);
		flex-direction:column;
		padding-block-end:$spacing-sm;

		.nav-wrapper
		{
			flex-grow:1;
		}
	}
}
</style>
